import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { API_CONFIG } from 'app/api-config/api-config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [RouterLink],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FooterComponent implements OnInit {
  private apiConfig = inject(API_CONFIG);
  hasAlfred: boolean = false;

  ngOnInit(): void {
    this.hasAlfred = this.apiConfig.environment !== null;
  }
}
